export enum ApplicationStatusExecutionEnum {
  Scheduled,
  InProgress,
  Closed,
}
